import React from 'react';
import ResetPasswordForm from 'src/components/UI/forms/ResetPassword';

const ResetPassword = () => <ResetPasswordForm />;

export default ResetPassword;
